var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPyramidchartThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 910,
    height: 785,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "full",
    viewBox: "0 0 910 785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 910,
    height: 785,
    x: 0,
    y: 0,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.5 50L129.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.5 50L216.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.5 50L302.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M388.5 50L388.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M474.5 50L474.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M560.5 50L560.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M646.5 50L646.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M733.5 50L733.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 50L819.5 715",
    fill: "none",
    stroke: "#dbdee4",
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 68.4722)",
    fill: "#54555a"
  }, "85+"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 105.4167)",
    fill: "#54555a"
  }, "80-84"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 142.3611)",
    fill: "#54555a"
  }, "75-79"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 179.3056)",
    fill: "#54555a"
  }, "70-74"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 216.25)",
    fill: "#54555a"
  }, "65-69"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 253.1944)",
    fill: "#54555a"
  }, "60-64"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 290.1389)",
    fill: "#54555a"
  }, "55-59"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 327.0833)",
    fill: "#54555a"
  }, "50-54"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 364.0278)",
    fill: "#54555a"
  }, "45-49"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 400.9722)",
    fill: "#54555a"
  }, "40-44"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 437.9167)",
    fill: "#54555a"
  }, "35-39"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 474.8611)",
    fill: "#54555a"
  }, "30-34"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 511.8056)",
    fill: "#54555a"
  }, "25-29"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 548.75)",
    fill: "#54555a"
  }, "20-24"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 585.6944)",
    fill: "#54555a"
  }, "15-19"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 622.6389)",
    fill: "#54555a"
  }, "10-14"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 659.5833)",
    fill: "#54555a"
  }, "5-9"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "end",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    transform: "translate(121.6914 696.5278)",
    fill: "#54555a"
  }, "0-4"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(129.6914 723)",
    fill: "#54555a"
  }, "120.000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(215.855 723)",
    fill: "#54555a"
  }, "90.000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(302.0186 723)",
    fill: "#54555a"
  }, "60.000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(388.1821 723)",
    fill: "#54555a"
  }, "30.000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(474.3457 723)",
    fill: "#54555a"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(560.5093 723)",
    fill: "#54555a"
  }, "30.000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(646.6729 723)",
    fill: "#54555a"
  }, "60.000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(732.8364 723)",
    fill: "#54555a"
  }, "90.000"), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "middle",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    y: 6,
    transform: "translate(819 723)",
    fill: "#54555a"
  }, "120.000"), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 55.7264l-28.0549 0l0 25.4917l28.0549 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 92.6708l-44.222 0l0 25.4917l44.222 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 129.6153l-78.024 0l0 25.4917l78.024 0Z",
    fill: "#009BD7",
    className: "zr0-cls-1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 166.5597l-91.3219 0l0 25.4917l91.3219 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 203.5042l-126.4192 0l0 25.4917l126.4192 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 240.4486l-144.6169 0l0 25.4917l144.6169 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 277.3931l-170.6527 0l0 25.4917l170.6527 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 314.3375l-206.5657 0l0 25.4917l206.5657 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 351.2819l-256.4458 0l0 25.4917l256.4458 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 388.2264l-278.7449 0l0 25.4917l278.7449 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 425.1708l-286.3675 0l0 25.4917l286.3675 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 462.1153l-258.6372 0l0 25.4917l258.6372 0Z",
    fill: "#009BD7",
    className: "zr0-cls-1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 499.0597l-205.2014 0l0 25.4917l205.2014 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 536.0042l-174.8661 0l0 25.4917l174.8661 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 572.9486l-153.3941 0l0 25.4917l153.3941 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 609.8931l-152.5641 0l0 25.4917l152.5641 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 646.8375l-157.6248 0l0 25.4917l157.6248 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 683.7819l-144.3326 0l0 25.4917l144.3326 0Z",
    fill: "rgb(0,155,215)",
    className: "zr0-cls-1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 55.7264l54.4381 0l0 25.4917l-54.4381 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 92.6708l65.7629 0l0 25.4917l-65.7629 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 129.6153l98.5108 0l0 25.4917l-98.5108 0Z",
    fill: "#E95000",
    className: "zr0-cls-2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 166.5597l101.7649 0l0 25.4917l-101.7649 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 203.5042l132.8901 0l0 25.4917l-132.8901 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 240.4486l147.3914 0l0 25.4917l-147.3914 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 277.3931l170.6929 0l0 25.4917l-170.6929 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 314.3375l202.292 0l0 25.4917l-202.292 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 351.2819l246.1693 0l0 25.4917l-246.1693 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 388.2264l262.9712 0l0 25.4917l-262.9712 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 425.1708l271.0534 0l0 25.4917l-271.0534 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 462.1153l253.5363 0l0 25.4917l-253.5363 0Z",
    fill: "#E95000",
    className: "zr0-cls-2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 499.0597l210.5464 0l0 25.4917l-210.5464 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 536.0042l172.2467 0l0 25.4917l-172.2467 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 572.9486l145.648 0l0 25.4917l-145.648 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 609.8931l147.5034 0l0 25.4917l-147.5034 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 646.8375l148.7528 0l0 25.4917l-148.7528 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M474.3457 683.7819l136.0178 0l0 25.4917l-136.0178 0Z",
    fill: "rgb(233,80,0)",
    className: "zr0-cls-2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5l147.3594 0l0 22l-147.3594 0Z",
    transform: "translate(386.3203 758)",
    fill: "rgb(0,0,0)",
    fillOpacity: 0,
    stroke: "#b7b9be",
    strokeWidth: 0,
    className: "zr0-cls-0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14 0l0 8l-14 0Z",
    transform: "translate(386.3203 760)",
    fill: "#009BD7",
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 19,
    y: 4,
    transform: "translate(386.3203 760)",
    fill: "#54555a"
  }, "Hombres"), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -2l67.6797 0l0 12l-67.6797 0Z",
    transform: "translate(386.3203 760)",
    fill: "none",
    className: "zr0-cls-3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l14 0l0 8l-14 0Z",
    transform: "translate(462 760)",
    fill: "#E95000",
    className: "zr0-cls-0"
  })), /*#__PURE__*/React.createElement("text", {
    dominantBaseline: "central",
    textAnchor: "start",
    style: {
      fontSize: 12,
      fontFamily: "sans-serif"
    },
    x: 19,
    y: 4,
    transform: "translate(462 760)",
    fill: "#54555a"
  }, "Mujeres"), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 -2l61.6797 0l0 12l-61.6797 0Z",
    transform: "translate(462 760)",
    fill: "none",
    className: "zr0-cls-3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramidchartThumb);
export default __webpack_public_path__ + "static/media/pyramidchart_thumb.c21370637ef484a49d07417cfd04c3e8.svg";
export { ForwardRef as ReactComponent };